import { useThemeLivePreviewContext } from '../modules/LivePreview/providers/ThemeLivePreviewProvider'
import { usePageLayoutContext } from '../providers/PageLayoutProvider'
import { useCurrentShopContext } from './useCurrentShopContext'
import { useThemeEditorContext } from './useThemeEditorContext'
import { useUpdateSectionMutation } from './useUpdateSectionMutation'

export const useSectionVisibility = () => {
  const { currentPageId, resetPreviewTimestamp } = useThemeEditorContext()
  const { currentShop } = useCurrentShopContext()
  const { pageLayoutQuery } = usePageLayoutContext()
  const { channel, setInspectorVisible } = useThemeLivePreviewContext()
  const { updateSectionMutation } = useUpdateSectionMutation()

  const changeSectionVisibility = ({
    sectionId,
    visible,
    forceReload = true,
  }: {
    sectionId: string
    visible: boolean
    forceReload?: boolean
  }) => {
    const block = pageLayoutQuery.data?.sectionsGroups.find((block) =>
      block.sections.some((section) => section.id === sectionId),
    )
    const section = block?.sections.find((section) => section.id === sectionId)

    setInspectorVisible(false)

    if (!block?.id || !currentPageId || !sectionId || !section) {
      throw new Error('changeSectionVisibility: Missing block ID or current page ID')
    }

    if (!forceReload) {
      channel.emit({
        action: 'ThemePreview:RemoveSection',
        payload: { id: section.sectionKey },
      })
    }

    updateSectionMutation.mutate(
      [
        {
          shop_id: currentShop.id,
          draft_section_id: section.id,
        },
        {
          visible,
          // NOTE: pass other fields to fulfill the schema
          name: section.name,
          customCss: section.customCss,
          customCssStatus: section.customCssStatus,
          colors: {
            type: 'Keep',
          },
        },
      ],

      {
        onSuccess: () => {
          pageLayoutQuery.refetch()

          if (forceReload) resetPreviewTimestamp()
        },
      },
    )
  }

  return {
    changeSectionVisibility,
  }
}
